import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Loader from './components/Loader';
import Home from './pages/Home';
import About from './pages/About';
import Education from './pages/Education';
import Employment from './pages/Employment';
import Contact from './pages/Contact';
import BatchDetails from './pages/BatchDetails';
import NotFound from './pages/NotFound';
import ServerConnectionError from './pages/ServerConnectionError';

// Set to true to display the hosting connection error / system check page.
// Set to false to restore regular website operations.
const IS_MAINTENANCE_MODE = true;

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  // When maintenance / system hold mode is active, display the server connection error
  if (IS_MAINTENANCE_MODE) {
    return <ServerConnectionError />;
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <main className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/education" element={<Education />} />
            <Route path="/employment" element={<Employment />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/batch/:batchId" element={<BatchDetails />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
